import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import api from '../../api';
import myAccountIcon from '../assets/myAccountIcon.png';
import Button from '../common/button/Button';
import Card from '../common/card/Card';
//import Form, { Input } from '../common/form/Form';
import { Alert } from 'antd';

 const  Signin =() =>{
 const [loading, setLoading] = useState(false);
 const [errorMessage, setErrorMessage] = useState(null);
 const [showPassword, setShowPassword] = useState(false);

  // hook up form and input fields with useForm
 const form = useForm();
 const {register, handleSubmit, control, formState }= form;
 const {errors } = formState;
   const onSubmit = async ({email, password}) => {
    setLoading(true);
    // delay feedback by at least 1 second`
    setTimeout(async () => {
      const res = await api.signin(email, password);
      if (res && res.error) {
        setErrorMessage(res.error);
        // res.error is the backend validation error message
        setLoading(false);
      }
      setLoading(false);
    }, 1000);
    return;
   };
 
 return ( 
    <Card
      className="w-full lg:max-w-2xl"
      backgroundClass="bg-blue-dark border-none"
      title="Please log into your account"
      titleClassName="text-center justify-center"
      ActionComponent_top={
        <img className="mx-auto mb-3" src={myAccountIcon} alt="account-icon" />
      }
      headerGroupClassName="flex-col mx-auto"     
     >

      <form onSubmit={handleSubmit(onSubmit)}  >
        <label  htmlFor="email" className="text-xs  text-white">Email</label>      
          <input type="email" id="email" placeholder="Email"  disabled={loading} error="errors.email" 
          {...register("email", {required: true})}
          aria-invalid={errors.email ? "true" : "false"}       
          className="ant-input p-4 my-2 h-auto text-lg border rounded-none"  
          />
          <div className='text-red-600'>
          {errors.email &&  <span> Email is required</span>}
          </div>
          {errors.email &&  
            <p role="alert">{errors.email?.message} </p>
          }
      
        <label htmlFor="password" className="text-xs  text-white" >Password</label>       
          <input type={!showPassword ? "password": "text"} id="password" placeholder="Password"  disabled={loading} {...register("password", {required: true})}   
          className="ant-input p-4 my-2 h-auto text-lg border rounded-none"  
          />
          <div className='text-red-600'>
          {errors.password &&  <span> Password is required</span>}
          </div>
            <p className="text-xs  text-white cursor-pointer"
            onClick={() => setShowPassword(!showPassword)}>
            {!showPassword ? 'Show Password' : 'Hide Password'}
            </p>
          <Link className=" text-white" to="/auth/forgot-credentials" style={{color: '#ffffff'}}> Forgot Password?</Link>
          <Button loading={loading} className="w-full ant-btn"   htmlType="submit"  
            > Sign In
          </Button>         
              {errorMessage && (
                    <Alert  description={errorMessage} type="error" role="alert"> 
                    </Alert>  )}
      </form>  

      <div className="mt-4 text-center" >
        <p className='font-bold text-white' style={{color: '#ffffff'}}>Don't have an account yet?</p>
        <Link className="text-white" to="/auth/signup" style={{color: '#ffffff'}}> Sign Up &rsaquo;</Link>
      </div>
    </Card>   
  );
};

export default Signin;
 